import type { QueryClient } from '@tanstack/react-query';
import { useAppEvent } from './useAppEvent';

/**
 * Wires the global `favoriteChanged` window event to react-query cache
 * invalidation for the favorites collection.
 */
export function useFavoritesEvents(queryClient: QueryClient) {
  useAppEvent('favoriteChanged', (detail) => {
    if (detail.isFavorite) {
      // Only invalidate favorites-related queries to avoid flicker
      queryClient.invalidateQueries({ queryKey: ['figures', 0] });
      queryClient.invalidateQueries({ queryKey: ['figures-grid', 0] });
    }

    // Keep existing logging behavior
    // eslint-disable-next-line no-console
    console.log(`Global favorite change detected for figure ${detail.figureId}, is favorite: ${detail.isFavorite}`);
  });
}

